import "./index.css"
import { getDecryptedItem } from "../../../helper/methods";
import { useInitiateHandshake } from "../../../hooks/useInitiateHandshake";
import { useLocation } from "react-router-dom";

function OldToNewRedirection() {
    const location = useLocation();
    const { initiateHandshake } = useInitiateHandshake();

    if (location.pathname.startsWith('/fab-plan/')) {
        return <></>;
    }

    const handleTryNewVersion = async () => {
        try {

            let userInfo = getDecryptedItem("userInfo");
            initiateHandshake({ panNo: userInfo?.paN_NO });
            return;
        } catch (error) {
            console.error('Error navigating to new version:', error);
        }
    };

    return (
        <>
          <div className="oldToNewWebsiteContainer">
            <div className="old-to-new-redirection">
                <div className="textContainer">
                    <span className="expText">
                        Experience the New Website, 
                    </span>
                    <span className="switchText">
                        Please switch to our new website to perform any actions.
                    </span>
                </div>

                <div>

                    <button type="button" className="switchToWebsiteBtn" onClick={handleTryNewVersion}>Switch to New Website</button>

                </div>

            </div>
            </div>
        </>
    )
}

export default OldToNewRedirection;